import {
  Avatar,
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material"
import { FormatCurrency } from "components/Currency"
import ImagePlaceholder from "icons/ImagePlaceholder"
import type React from "react"
import type { Offer } from "../../offersList/offersListTypes"

interface MenuOfferItemProps {
  offer: Offer
  checked: boolean
  onClick: () => void
}

const MenuOfferItem: React.FC<MenuOfferItemProps> = ({
  offer,
  checked,
  onClick,
}) => {
  const { AccommodationName, OfferTitle, Nights, LeadInPrice, ImageURL } = offer

  return (
    <ListItem
      onClick={onClick}
      alignItems="flex-start"
      sx={(theme) => ({
        padding: 2,
        cursor: "pointer",
        transition: "background-color 0.2s ease",
        backgroundColor: checked
          ? theme.palette.action.selected
          : "transparent",
        "&:hover": {
          backgroundColor: checked
            ? theme.palette.action.selected
            : theme.palette.action.hover,
        },
      })}
    >
      <ListItemAvatar>
        <Avatar
          variant="rounded"
          alt={`${OfferTitle} - ${AccommodationName}`}
          src={ImageURL}
          sx={{ width: 96, height: 96, marginRight: 2 }}
        >
          <ImagePlaceholder />
        </Avatar>
      </ListItemAvatar>

      <ListItemText
        disableTypography
        primary={
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography variant="subtitle1" component="h3" fontWeight="medium">
              {OfferTitle || "Título não disponível"}
            </Typography>
            <Typography variant="subtitle1" component="p" fontWeight="medium">
              <FormatCurrency value={LeadInPrice} />
            </Typography>
          </Box>
        }
        secondary={
          <>
            <Typography
              component="span"
              variant="body2"
              color="text.secondary"
              display="block"
            >
              {AccommodationName}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                marginTop: 1,
              }}
            >
              {Nights ? (
                <Typography variant="body2" color="text.secondary">
                  {Nights} Noites
                </Typography>
              ) : (
                <Typography variant="caption" color="text.disabled">
                  Duração não especificada
                </Typography>
              )}
            </Box>
          </>
        }
      />
    </ListItem>
  )
}

export default MenuOfferItem
